module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ieditoredit"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 14,
      "lg": 10
    }
  }, [(_vm.editForm.edittime) ? _c('span', {
    staticClass: "header-tips fs-label"
  }, [_vm._v("上次保存于 " + _vm._s(_vm.editForm.edittime))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 8,
      "lg": 4
    }
  }, [_c('span', {
    staticClass: "header-btn"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelForm
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('editForm')
      }
    }
  }, [_vm._v("保存")])], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "editor-content"
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.rules,
      "label-width": "5rem"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类",
      "required": ""
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "start",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.editForm.category),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "category", $$v)
      },
      expression: "editForm.category"
    }
  }, _vm._l((_vm.formatCategory), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 2
    }
  }, [_vm._v("热度")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hotindex"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "热度"
    },
    on: {
      "change": _vm.handleHotChange
    },
    model: {
      value: (_vm.editForm.hotindex),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotindex", $$v)
      },
      expression: "editForm.hotindex"
    }
  }, _vm._l((_vm.formatHotlist), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入标题",
      "icon": "circle-cross",
      "on-icon-click": _vm.handleTitleIconClick
    },
    model: {
      value: (_vm.editForm.title),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "title", $$v)
      },
      expression: "editForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 10,
        maxRows: 20
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.editForm.content),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "content", $$v)
      },
      expression: "editForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容来源",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sourcefrom"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "multiple-limit": 1,
      "filterable": "",
      "allow-create": "",
      "placeholder": "请选择内容来源"
    },
    on: {
      "change": _vm.handleSfChange
    },
    model: {
      value: (_vm.editForm.sourcefrom),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sourcefrom", $$v)
      },
      expression: "editForm.sourcefrom"
    }
  }, _vm._l((_vm.formatSourcefromlist), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 2
    }
  }, [_vm._v("  ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sourceurl"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "详细网址",
      "trigger-on-focus": false,
      "icon": "circle-cross",
      "on-icon-click": _vm.handleSourceurlChange
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.editForm.sourceurl),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sourceurl", $$v)
      },
      expression: "editForm.sourceurl"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面图片",
      "prop": "cover"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "封面图片链接",
      "icon": "circle-cross",
      "on-icon-click": _vm.handleCoverChange
    },
    model: {
      value: (_vm.editForm.cover),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cover", $$v)
      },
      expression: "editForm.cover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签",
      "prop": "labels"
    }
  }, [_c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 24
    }
  }, [_vm._l((_vm.editForm.labels), function(tag) {
    return _c('el-tag', {
      key: tag.id,
      staticClass: "editor-content-tags",
      attrs: {
        "type": "gray",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleLabelClose(tag)
        }
      }
    }, [_vm._v("\n              " + _vm._s(tag) + "\n              ")])
  }), _vm._v(" "), _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.reqRcmdLabels
    }
  }, [_vm._v("获取推荐标签")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "newlabels"
    }
  }, [_c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 24
    }
  }, [_vm._l((_vm.editForm.newlabels), function(newtag) {
    return _c('el-tag', {
      key: newtag.id,
      staticClass: "editor-content-tags",
      attrs: {
        "type": "gray",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(newtag)
        }
      }
    }, [_vm._v("\n              " + _vm._s(newtag) + "\n              ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ 新标签")])], 2)], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16ee7de4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ieditor/edit.vue
// module id = 754
// module chunks = 6